import { render } from "./TaskBasicAddModal.vue?vue&type=template&id=5b84c63b&scoped=true&ts=true"
import script from "./TaskBasicAddModal.vue?vue&type=script&lang=ts"
export * from "./TaskBasicAddModal.vue?vue&type=script&lang=ts"

import "./TaskBasicAddModal.vue?vue&type=style&index=0&id=5b84c63b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b84c63b"]])

export default __exports__